<template>
    <div class="su-custom-gallery su-custom-gallery-title-never card_main_photo image_container">
        <slot></slot>
        <div class="su-clear"></div>
    </div>
</template>

<script>
export default {
    name: "PictureWraper",
};
</script>

<style scoped>
.image_container {
    display: flex;
    flex-direction: row;
    padding: 10px;
}
</style>
